<template>
  <CountryPage country="usa" />
</template>